'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const FileIsNotAnImageError = ({
  filename
}) => /*#__PURE__*/_jsx("div", {
  className: "m-bottom-2",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "FileManagerLib.notifications.upload.expectedImage.message",
    options: {
      filename
    }
  })
});
export default FileIsNotAnImageError;